// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n#room-last-commands[data-v-b8b81f4a]  .v-expansion-panel-content__wrap {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
